define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/payme_form"
], function($, _, Marionette, CommonView, PaymeForm) {

    return CommonView.extend({

        ui: _.extend(CommonView.prototype.ui, {
            'currencySelect':'#currency_abbr',
            'bankSelect':'#bank_code',
            'amount' : '#amount'
        }),

        events: _.extend(CommonView.prototype.events, {
            'keyup @ui.amount': 'updateUsdAmount',
        }),

        initialize: function(){
            this.bindUIElements();
            this.form = new PaymeForm();

            if(window.form_error)
            {
                this.triggerMethod('show:errors', window.form_error);
                window.form_error = null;
            }

            this.setScheduler();
        },

        setScheduler: function ()
        {
            window.setInterval(this.requestWithdrawableAmount, 2000);
        },

        updateUsdAmount: function() {
            $('#usd_amount').text( "$ "+ ($('#amount').val()*window.fx_rates).toFixed(2));
        },

        requestWithdrawableAmount: function() {
            const mt4AccountNo = $('#mt4_account_no').find(":selected").val();
            const currency = window.currentCurrency;

            $.ajax({
                url: `/rest_withdrawal/withdrawable_amount?mt4_account_no=${mt4AccountNo}&currency=${currency}`,
                method: "GET",
                success: function(data) {
                    $('#withdrawable_amount').text(data.freeMargin);
                }
            })
        },
    });
});
